import React from 'react'

const p = "animate-pulse bg-white/5 rounded-lg"

export const SkLine = ({ w = "w-full", h = "h-4", extra = "" }) => (
    <div className={`${p} ${w} ${h} ${extra}`} />
)
export const SkBox = ({ className = "" }) => <div className={`${p} ${className}`} />

export function SkeletonHero() {
    return (
        <div className="w-full min-h-[75svh] md:h-[75vh] flex flex-col md:flex-row bg-[#0f0e17]">
            <div className="w-full md:w-1/2 h-[45vmin] md:h-full animate-pulse bg-white/5 flex-shrink-0" />
            <div className="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-12 py-8 gap-5">
                <SkBox className="h-6 w-24 rounded-full" />
                <div className="space-y-3">
                    <SkBox className="h-10 w-3/4 rounded-xl" />
                    <SkBox className="h-10 w-1/2 rounded-xl" />
                </div>
                <div className="space-y-2">
                    <SkLine h="h-4" />
                    <SkLine h="h-4" w="w-5/6" />
                    <SkLine h="h-4" w="w-4/5" />
                </div>
                <div className="flex flex-col gap-2">
                    <SkLine h="h-5" w="w-52" />
                    <SkLine h="h-5" w="w-48" />
                    <SkLine h="h-5" w="w-36" />
                </div>
                <SkBox className="h-12 w-44 rounded-full" />
            </div>
        </div>
    )
}

export function SkeletonEventRow({ count = 3 }) {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="flex flex-col sm:flex-row bg-[#16151c] rounded-2xl overflow-hidden border border-white/5 h-auto sm:h-40">
                    <div className="sm:w-44 md:w-52 h-40 sm:h-full animate-pulse bg-white/5 flex-shrink-0" />
                    <div className="flex-1 p-5 flex flex-col justify-between gap-3">
                        <div>
                            <SkLine h="h-5" w="w-3/5" extra="mb-2" />
                            <SkLine h="h-3" extra="mb-1.5" />
                            <SkLine h="h-3" w="w-4/5" />
                        </div>
                        <div className="flex gap-2 flex-wrap">
                            <SkBox className="h-7 w-20 rounded-full" />
                            <SkBox className="h-7 w-28 rounded-full" />
                            <SkBox className="h-7 w-24 rounded-full" />
                        </div>
                        <SkBox className="h-9 w-36 rounded-full" />
                    </div>
                </div>
            ))}
        </div>
    )
}

export function SkeletonCard({ count = 6, imageHeight = "h-52" }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="flex flex-col bg-[#16151c] border border-white/5 rounded-2xl overflow-hidden">
                    <div className={`${imageHeight} animate-pulse bg-white/5`} />
                    <div className="p-5 flex flex-col gap-3">
                        <SkLine h="h-5" w="w-3/4" />
                        <div className="space-y-1.5">
                            <SkLine h="h-3" w="w-36" />
                            <SkLine h="h-3" w="w-32" />
                            <SkLine h="h-3" w="w-44" />
                        </div>
                        <SkLine h="h-3" />
                        <SkLine h="h-3" w="w-5/6" />
                        <SkBox className="h-9 w-full rounded-full mt-1" />
                    </div>
                </div>
            ))}
        </div>
    )
}

export function SkeletonEventDetail() {
    return (
        <div className="w-full min-h-screen bg-[#0f0e17] text-white pb-28 lg:pb-0">
            <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 py-6 lg:py-10 items-start">
                    <div className="flex flex-col gap-4">
                        <SkBox className="rounded-2xl aspect-[3/4] w-full" />
                        <SkBox className="rounded-2xl h-64" />
                    </div>
                    <div className="bg-[#16151c] rounded-2xl border border-white/5 p-4 sm:p-6 flex flex-col gap-5">
                        <div className="text-center flex flex-col items-center gap-3">
                            <SkBox className="h-9 w-2/3 rounded-xl" />
                            <SkBox className="h-9 w-1/2 rounded-xl" />
                            <SkBox className="h-24 w-full rounded-xl" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <SkBox className="h-9 w-full rounded-full" />
                            <SkBox className="h-9 w-full rounded-full" />
                            <SkBox className="h-9 w-3/4 rounded-full" />
                        </div>
                        <SkLine h="h-5" w="w-24" extra="mx-auto" />
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {[0, 1, 2, 3].map(i => <SkBox key={i} className="h-28 rounded-2xl" />)}
                        </div>
                        <SkBox className="h-12 w-full rounded-full" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export function SkeletonMyTickets({ count = 6 }) {
    return (
        <div className="bg-[#0f0e17] min-h-screen py-12 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10">
                    <SkBox className="h-4 w-20 rounded-full mx-auto mb-3" />
                    <SkBox className="h-9 w-48 rounded-xl mx-auto" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {Array.from({ length: count }).map((_, i) => (
                        <div key={i} className="bg-[#16151c] border border-white/5 rounded-2xl overflow-hidden">
                            <div className="h-44 animate-pulse bg-white/5" />
                            <div className="p-4 flex flex-col gap-2">
                                <SkLine h="h-3" w="w-36" />
                                <SkLine h="h-3" w="w-28" />
                                <SkLine h="h-3" w="w-44" />
                                <SkBox className="h-7 w-28 rounded-full mt-1" />
                                <SkBox className="h-9 w-full rounded-full mt-2" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export function SkeletonPayment() {
    return (
        <div className="bg-[#0f0e17] min-h-screen">
            <div className="max-w-6xl mx-auto p-6 lg:p-12 grid lg:grid-cols-2 gap-10">
                <SkBox className="rounded-xl h-72 lg:h-auto" />
                <div className="bg-[#16151c] border border-white/5 rounded-xl p-8 flex flex-col gap-4">
                    <SkLine h="h-7" w="w-40" />
                    <SkBox className="h-16 w-full rounded-lg" />
                    <div className="space-y-2 py-2">
                        <SkLine h="h-4" />
                        <SkLine h="h-4" w="w-5/6" />
                    </div>
                    <SkBox className="h-10 w-full rounded-lg" />
                    <SkBox className="h-10 w-full rounded-lg" />
                    <div className="space-y-2 pt-4 border-t border-white/5">
                        <SkLine h="h-4" />
                        <SkLine h="h-4" />
                        <SkBox className="h-6 w-full rounded mt-2" />
                    </div>
                    <SkBox className="h-48 w-full rounded-lg" />
                    <SkBox className="h-12 w-full rounded-full" />
                </div>
            </div>
        </div>
    )
}

export function SkeletonEventsPage({ count = 9 }) {
    return (
        <div className="bg-[#0f0e17] min-h-screen py-14 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10 flex flex-col items-center gap-3">
                    <SkBox className="h-4 w-20 rounded-full" />
                    <SkBox className="h-9 w-56 rounded-xl" />
                </div>
                <SkBox className="h-12 w-full max-w-lg mx-auto rounded-full mb-8" />
                <SkeletonCard count={count} />
            </div>
        </div>
    )
}

export function SkeletonNewsPage({ count = 6 }) {
    return (
        <div className="bg-[#0f0e17] min-h-screen py-14 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10 flex flex-col items-center gap-3">
                    <SkBox className="h-4 w-16 rounded-full" />
                    <SkBox className="h-9 w-36 rounded-xl" />
                    <SkBox className="h-4 w-52 rounded" />
                </div>
                <SkeletonCard count={count} imageHeight="h-44" />
            </div>
        </div>
    )
}

export function SkeletonHomeNews({ count = 3 }) {
    return (
        <div className="bg-[#0a0a0f] py-16 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10 flex flex-col items-center gap-3">
                    <SkBox className="h-4 w-16 rounded-full" />
                    <SkBox className="h-9 w-48 rounded-xl" />
                </div>
                <SkeletonCard count={count} imageHeight="h-44" />
            </div>
        </div>
    )
}

export function SkeletonHomeEvents() {
    return (
        <div className="bg-[#0f0e17] text-white py-14 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10 flex flex-col items-center gap-3">
                    <SkBox className="h-4 w-24 rounded-full" />
                    <SkBox className="h-9 w-56 rounded-xl" />
                </div>
                <div className="flex gap-3 mb-8 justify-center">
                    <SkBox className="h-10 w-28 rounded-full" />
                    <SkBox className="h-10 w-28 rounded-full" />
                </div>
                <SkeletonEventRow count={3} />
            </div>
        </div>
    )
}
